import services from '@/config/services'
import FileManager from '@/services/ask-file-manager/index.js'


export default class PraticheService{
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_pratiche.url}` 
    this.praticheBase = `${services.ask_pratiche_base.url}` 
    this.apiUrl = `${services. ask_api.url}/management`
    this.filemanager = new FileManager()
  }

  async getAllFatture(){
    let items = []
    const url = `${this.baseUrl}/get-fatture-all`

    try {
      let res =  await this.http.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async UploadZipMpsOrBPM(formData) {
    const url = `${this.apiUrl}/AreaFlussi/caricamento-flows/UploadZipMpsOrBPM`;
    try {
      const response = await this.http.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response;
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  }


  async getPreviewData(params) {
    const url = `${this.apiUrl}/AreaFlussi/caricamento-flows/GetPreviewData`;
    try {
      const response = await this.http.get(url, { params });
      return response;
    } catch (error) {
      console.error('Error getting preview data:', error);
      throw error;
    }
  }


  async getRiepilogoGettoni(idAgente, mese, codiceImportazione = '') {
    let items = []
    const url = `${this.apiUrl}/AreaFlussi/caricamento-flows/getRiepilogoGettoni`

    try {
      let res = await this.http.get(url, {
        params: {
          id_agente: idAgente,
          mese: mese,
          ...(codiceImportazione.trim() ? { codice_importazione: codiceImportazione.trim() } : {})
        }
      })
      items = res.data.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      }
    }
  }

  async processInvoices(invoices) {
    const url = `${this.apiUrl}/AreaFlussi/caricamento-flows/ProcessInvoices`
    try {
      const response = await this.http.post(url, { invoices })
      return response
    } catch (error) {
      console.error('Error processing invoices:', error)
      throw error
    }
  }


  async getAllFattureVendita(){
    let items = []
    const url = `${this.baseUrl}/get-fatture-vendita-all`

    try {
      let res =  await this.http.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getFattureDetails(id){
    let items = []
    const url = `${this.baseUrl}/get-fatture-details/${id}`

    try {
      let res =  await this.http.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async getBilancioFattAcquisto(data_emissione, data_competenza, distributore){
    let items = []
    const url = `${this.baseUrl}/bilancio/fatture/acquisto/${data_emissione}/${data_competenza}/${distributore}`

    try {
      let res =  await this.http.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getBilancioFattFornitori(data_emissione, data_competenza, fornitore){
    let items = []
    const url = `${this.baseUrl}/bilancio/fatture/fornitori/${data_emissione}/${data_competenza}/${fornitore}`

    try {
      let res =  await this.http.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getDistributori(){
    let items = []
    const url = `${this.baseUrl}/distributori/fatture/acquisto`

    try {
      let res =  await this.http.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getAllPun(){
    let items = []
    const url = `${this.baseUrl}/get-pun`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async editPun(value){
    const url = `${this.baseUrl}/edit-pun`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async createPun(value){
    const url = `${this.baseUrl}/create-pun`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async deletePun(value){

    const url = `${this.baseUrl}/delete-pun`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async deletePuns(value){
    const url = `${this.baseUrl}/delete-puns`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async getAllTariffe(){
    let items = {}
    const url = `${this.baseUrl}/get-tariffe-energy`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async createTariffa(value){
    const url = `${this.baseUrl}/create-tariffa-energy`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async editTariffe(value){
    const url = `${this.baseUrl}/edit-tariffe-energy`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async deleteTariffa(value){

    const url = `${this.baseUrl}/delete-tariffa-energy`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async deleteTariffe(value){

    const url = `${this.baseUrl}/delete-tariffe-energy`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async getAllTariffeGas(){
    let items = {}
    const url = `${this.baseUrl}/get-tariffe-gas`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getStatisticheTariffeGas(dataDa, dataA, codTypeClients) {
    const url = `${this.baseUrl}/statistiche-tariffe-gas`
    const ids = Array.isArray(codTypeClients) ? codTypeClients : [codTypeClients]
    try {
      const res = await this.http.post(url, {
        data_da: dataDa,
        data_a: dataA,
        cod_type_clients: ids,
      })
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async createTariffaGas(value){
    const url = `${this.baseUrl}/create-tariffa-gas`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async editTariffeGas(value){
    const url = `${this.baseUrl}/edit-tariffe-gas`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async deleteTariffaGas(value){

    const url = `${this.baseUrl}/delete-tariffa-gas`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async deleteTariffeGas(value){

    const url = `${this.baseUrl}/delete-tariffe-gas`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async previewImportTariffeGas(file) {
    const url = `${this.baseUrl}/preview-import-tariffe-gas`
    const formData = new FormData()
    formData.append('fileimport', file)
    try {
      const res = await this.http.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async importTariffeGas(file) {
    const url = `${this.baseUrl}/import-tariffe-gas`
    const formData = new FormData()
    formData.append('fileimport', file)
    try {
      const res = await this.http.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      this.eventBus.emit('data-load-success', {
        message: res.data?.message || 'Import tariffe gas completato',
      })
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  
  async getEstrattiConto(dateFrom = undefined, dateTo = undefined, used = 0, lazy = 0, tab = undefined, includeNotes = undefined){
    let items = {}
    let url = `${this.baseUrl}/get-estratti-conto/${dateFrom}/${dateTo}/${used}`
    const params = new URLSearchParams()
    if (lazy) {
      params.append('lazy', '1')
    }
    if (tab) {
      params.append('tab', tab)
    }
    if (includeNotes !== undefined && includeNotes !== null) {
      params.append('include_notes', includeNotes ? '1' : '0')
    }
    const query = params.toString()
    if (query) {
      url = `${url}?${query}`
    }

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getEstrattiContoCounts(dateFrom = undefined, dateTo = undefined, used = 0){
    let items = {}
    const url = `${this.baseUrl}/get-estratti-conto-counts/${dateFrom}/${dateTo}/${used}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getTypesPay(){
    let items = {}
    const url = `${this.baseUrl}/get-types-pay`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getTypesPayMode(){
    let items = {}
    const url = `${this.baseUrl}/get-types-pay-mode`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async editEstrattoConto(value){
    const url = `${this.baseUrl}/estratti-conto/edit`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
        return true
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
        return false
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async saveMovimento(dateContabile, dateValuta, valueMovement, descriptionMovement, cod_type_pay_mode, type_pay){
 
    const url = `${this.baseUrl}/save-movement`

    try {
        let res = await this.http.post(url, {
          data: {
            dateContabile,
            dateValuta,
            valueMovement,
            descriptionMovement,
            cod_type_pay_mode,
            type_pay
          }
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async deleteEstrattiConto(value){
    
    const url = `${this.baseUrl}/delete-estratti-conto`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async regMassiva(value, type_pay_mode){
    
    const url = `${this.baseUrl}/regolarizzazione-massiva`

    try {
        let res = await this.http.post(url, {
          value, 
          type_pay_mode
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async uploadFile(fileFormData){
    let items = {}
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/upload-file-estratti-conto`

    try {
        let res = await this.http.post(url, fileFormData,  settings)
        //this.eventBus.emit('data-load-success', {message: res.data})
        items = res.data
        return {
          items,
        }
    } finally {
        this.eventBus.emit('data-loaded')
    }

  }

  async uploadFileEstrattoBanca(fileFormData){
    let items = {}
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/upload-file-estratto-banca`

    try {
        let res = await this.http.post(url, fileFormData,  settings)
        items = res.data
        return {
          items,
        }
    } finally {
        this.eventBus.emit('data-loaded')
    }
  }

  // ── Controlli estratti conto banca ──────────────────────────────────
  // Il caricamento (uploadFileEstrattoBanca) sta nella pagina Estratti Conto,
  // l'esecuzione e lo storico nella pagina Controlli Estratti Conto.

  async getDocumentiEstrattoBanca(codTypePayMode = null){
    const url = `${this.baseUrl}/controlli-estratto-banca/documenti`

    try {
      const res = await this.http.get(url, { params: codTypePayMode ? { codTypePayMode } : {} })
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return { documenti: [], conti: [] }
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getEsecuzioniEstrattoBanca(params = {}){
    const url = `${this.baseUrl}/controlli-estratto-banca/esecuzioni`

    try {
      const res = await this.http.get(url, { params })
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return { esecuzioni: [] }
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  // L'errore non viene ingoiato: chi lancia il controllo deve sapere perche' non e' riuscito.
  async eseguiControlloEstrattoBanca(idFile, dates = null){
    const url = `${this.baseUrl}/controlli-estratto-banca/esegui`

    try {
      const res = await this.http.post(url, { idFile, dates })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getEsitoEstrattoBanca(id){
    const url = `${this.baseUrl}/controlli-estratto-banca/esecuzione/${id}`

    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async scaricaEstrattoBanca(id){
    const url = `${this.baseUrl}/controlli-estratto-banca/scarica/${id}`

    try {
      const res = await this.http({ url, method: 'GET', responseType: 'blob' })
      this.filemanager.download(res)
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  // L'errore non viene ingoiato: chi crea un movimento deve sapere perche' non e' riuscito.
  async creaMovimentoEstrattoBanca(payload){
    const url = `${this.baseUrl}/controlli-estratto-banca/crea-movimento`

    try {
      const res = await this.http.post(url, payload)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getContiControlloPagamenti(){
    const url = `${this.baseUrl}/controllo-pagamenti/conti`

    try {
      const res = await this.http.get(url)
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return { conti: [] }
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async eseguiControlloPagamenti(payload){
    const url = `${this.baseUrl}/controllo-pagamenti/esegui`

    try {
      const res = await this.http.post(url, payload)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getMovimentiSenzaPagamenti(params){
    const url = `${this.baseUrl}/controllo-pagamenti/senza-pagamenti`

    try {
      const res = await this.http.get(url, { params })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getAuditControlloPagamenti(){
    const url = `${this.baseUrl}/controllo-pagamenti/audit`

    try {
      const res = await this.http.get(url)
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return { movimenti: [] }
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getAuditEstrattoBanca(params = {}){
    const url = `${this.baseUrl}/controlli-estratto-banca/audit`

    try {
      const res = await this.http.get(url, { params })
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return { movimenti: [] }
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async saveMovimenti(array){
    
    const url = `${this.baseUrl}/save-movements`

    try {
        let res = await this.http.post(url, {
          data: array
        })
        this.eventBus.emit('data-load-success', {message: res.data})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async getMassiveTypes(){
    let items = []
    const url = `${this.baseUrl}/get-massive-types`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getProviders(){
    let items = []
    const url = `${this.baseUrl}/get-providers`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getMassiveRequest(){
    let items = {}
    const url = `${this.baseUrl}/get-massive-request`
    // const url = 'http://processi.askmanagement.it/api/pratiche/v1/get-massive-request'

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getMassiveRequestSearch(fornitura, type, period){
    let items = {}
    const url = `${this.baseUrl}/get-massive-request-search`
    
    try {
      let res = await this.http.post(url, { 
        fornitura, 
        type,
        period  
      })
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getPodId(podCode){
    let item = ''
    const url = `${this.baseUrl}/get-pod-id/${podCode}`

    try {
        let res = await this.http.get(url)
        item = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            item,
        }
    }

  }


  async getPreviews(){
    let items = {}
    const url = `${this.baseUrl}/get-preview/month/summary`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getPreviewDetails(date, stima){
    let items = {}
    const url = `${this.baseUrl}/get-preview/month/details/${date}/${stima}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getEstrattoConto(id){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/${id}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async splitMovements(id, import1, import2, descrizione, type_pay, type_pay_mode, data_contabile, data_valuta ){

    let itemId = null
    const url = `${this.baseUrl}/estratto-conto/detail/split-movements`
    
    try {
      let res = await this.http.post(url, {  
        id, import1, import2, descrizione, type_pay, type_pay_mode, data_contabile, data_valuta  
      })
      itemId = res.data.newId
      this.eventBus.emit('data-load-success', {message: res.data.message})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
          itemId,
      }
    }

  }



  async getSuggerimenti(resource, search){
    let items = {}
    const url = `${this.baseUrl}/suggerimenti/${resource}/details?&filters[search]=${search}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }

  async getFattureVendita(numeri) {
    let items = {};

    const query = Array.isArray(numeri)
      ? numeri.filter(v => v !== null && v !== undefined && String(v).trim() !== '').join(',')
      : String(numeri ?? '').trim();

    if (query === '') {
      this.eventBus.emit('data-loaded');
      return { items };
    }

    const url = `${this.baseUrl}/suggerimenti/fatture-vendita/details?filters[search]=${encodeURIComponent(query)}`;

    try {
      const res = await this.http.get(url);
      items = res.data ?? {};
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
    } finally {
      this.eventBus.emit('data-loaded');
    }

    return { items };
  }

  async getRappresentanti(){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/rappresentanti`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async getRappresentanteSaldo(id){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/rappresentante/saldo/${id}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }


  async getFattureDaSaldareRapp(idRapp){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/rappresentante/fatture-da-saldare/${idRapp}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }


  async associateToPayments(obj){
    
    const url = `${this.baseUrl}/estratto-conto/detail/associate-to-payments`

    try {
        let res = await this.http.post(url, {
          data: obj
        })
        this.eventBus.emit('data-load-success', {message: res.data.message})
        return res.data.response
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async associateNoteToPayments(obj){
    
    const url = `${this.baseUrl}/estratto-conto/detail/associate-note-to-payments`

    try {
        let res = await this.http.post(url, {
          data: obj
        })
        if (res.data.response) {
          this.eventBus.emit('data-load-success', {message: res.data.message})
        }
        return res.data.response
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async dissociateToPayments(estrattoConto, fatture, fornitori){
    
    const url = `${this.baseUrl}/estratto-conto/detail/dissociate-to-payments`

    try {
        let res = await this.http.post(url, {
          estrattoConto, fatture, fornitori
        })
        if (res.data.response) {
          this.eventBus.emit('data-load-success', {message: res.data.message})
        } 
        return res.data.response
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async substituteNumberInvoice(newNumero, oldPayment){
    
    const url = `${this.baseUrl}/estratto-conto/detail/substitute-payment`

    try {
        let res = await this.http.post(url, {
          data: {newNumero, oldPayment}
        })

        this.eventBus.emit('data-load-success', {message: res.data})
        return true
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
        return false
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  
  async getPrevNextDetail(idEstrattoConto){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/prev-next/${idEstrattoConto}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getClienti(){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/clienti`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getClientiSuggeriti(ricerca) {
    let items = {};
    const url = `${this.baseUrl}/estratto-conto/detail/clienti-suggeriti`;

    try {
      const res = await this.http.get(url, { params: { ricerca } });
      items = res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
    } finally {
      this.eventBus.emit('data-loaded');
    }

    return { items };
  }

  async getFattureDaSaldareClient(idClient){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/cliente/fatture-da-saldare/${idClient}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getFornitori(){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/fornitori`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getFattureDaSaldareFornitore(idFornitore){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/fornitore/fatture-da-saldare/${idFornitore}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async getTypesPayModeGiroconto(cod_type_pay_mode){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/get-types-pay-mode/${cod_type_pay_mode}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async associateToConto(idEstrattoConto, idTypePayMode){

    const url = `${this.baseUrl}/estratto-conto/detail/associate-to-conto`

    try {
        let res = await this.http.post(url, {
          data: {
            'idEstrattoConto' : idEstrattoConto,
            'idTypePayMode' : idTypePayMode
          }
        })
        this.eventBus.emit('data-load-success', {message: res.data.message})
        return res.data.response
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async associateToCommercialista(estrattoConto, nota){

    const url = `${this.baseUrl}/estratto-conto/detail/associate-to-commercialista`

    try {
        let res = await this.http.post(url, {
          estrattoConto,
          nota
        })
        this.eventBus.emit('data-load-success', {message: res.data.message})
        return res.data.response
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async searchMovimentoIgnotoSuggestions(estrattoConto){

    const url = `${this.baseUrl}/estratto-conto/detail/search-movimento-ignoto-suggestions`

    try {
        let res = await this.http.post(url, { estrattoConto })
        this.eventBus.emit('data-load-success', {message: res.data.message})
        return res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
    }

  }

  async associateToMovimentoIgnoto(estrattoConto){

    const url = `${this.baseUrl}/estratto-conto/detail/associate-to-movimento-ignoto`

    try {
        let res = await this.http.post(url, {
          estrattoConto
        })
        this.eventBus.emit('data-load-success', {message: res.data.message})
        return res.data.response
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
    }

  }

  async getMovimentiIgnotiGestione(view = null, showSuggested = false, page = 1, showAssigned = false){
    const url = `${this.baseUrl}/movimenti-ignoti/gestione`
    try {
      const params = { show_suggested: showSuggested, show_assigned: showAssigned, page }
      if (view) params.view = view
      const res = await this.http.get(url, { params })
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    }
  }

  async assignMovimentoIgnotoSuggestion(movimentoIgnotoId, suggerimentoId){
    const url = `${this.baseUrl}/movimenti-ignoti/gestione/assegna-suggerimento`
    try {
      const res = await this.http.post(url, {
        movimento_ignoto_id: movimentoIgnotoId,
        suggerimento_id: suggerimentoId
      })
      this.eventBus.emit('data-load-success', {message: res.data.message})
      return res.data.response
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return false
    }
  }

  async assignManualMovimentoIgnotoSuggestion(movimentoIgnotoId, numeroFattura, isInstallment = false){
    const url = `${this.baseUrl}/movimenti-ignoti/gestione/assegna-suggerimento-manuale`
    try {
      const res = await this.http.post(url, {
        movimento_ignoto_id: movimentoIgnotoId,
        numero_fattura: numeroFattura,
        is_dilazione: isInstallment
      })
      this.eventBus.emit('data-load-success', {message: res.data.message})
      return res.data.response
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return false
    }
  }

  async unassignMovimentoIgnotoSuggestion(movimentoIgnotoId){
    const url = `${this.baseUrl}/movimenti-ignoti/gestione/dissocia-suggerimento`
    try {
      const res = await this.http.post(url, { movimento_ignoto_id: movimentoIgnotoId })
      this.eventBus.emit('data-load-success', {message: res.data.message})
      return res.data.response
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return false
    }
  }

  async associateMovimentoIgnotoPayment(movimentoIgnotoId, suggerimentoId = null){
    const url = `${this.baseUrl}/movimenti-ignoti/gestione/associa-pagamento`
    try {
      const data = { movimento_ignoto_id: movimentoIgnotoId }
      if (suggerimentoId) data.suggerimento_id = suggerimentoId
      const res = await this.http.post(url, data)
      this.eventBus.emit('data-load-success', {message: res.data.message})
      return res.data.response
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return false
    }
  }

  async deleteMovimentoIgnoto(movimentoIgnotoId, nota){
    const url = `${this.baseUrl}/movimenti-ignoti/gestione/elimina`
    try {
      const res = await this.http.post(url, {
        movimento_ignoto_id: movimentoIgnotoId,
        nota
      })
      this.eventBus.emit('data-load-success', {message: res.data.message})
      return res.data.response
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return false
    }
  }


  
  async getPaymentsAssociated(idEstrattoConto){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/get-payments-associated/${idEstrattoConto}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async getNoteDetail(idFattura, typeNote){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/note/${typeNote}/${idFattura}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getRids(estrattoConto, period){
    if (period) {
      estrattoConto.period = period
    }

    let items = {}
    const url = `${this.baseUrl}/estratto-conto/detail/get-rids`

    try {
        let res = await this.http.post(url, {
          estrattoConto
        })
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


async getCombinationsRid(estrattoConto, period){

  if (period) {
    estrattoConto.period = period
  }

  let items = {}
  const url = `${this.baseUrl}/estratto-conto/detail/get-combinations-rid`

  try {
      let res = await this.http.post(url, {
          estrattoConto
      })
      items = res.data
  } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
  } finally {
      this.eventBus.emit('data-loaded')      
      // eslint-disable-next-line no-unsafe-finally
      return {
          items,
      }
  }

}

  
  

  
  async associateToRids(obj){
  
      const url = `${this.baseUrl}/estratto-conto/detail/associate-to-rids`

      try {
          let res = await this.http.post(url, {
              data: obj
          })
          this.eventBus.emit('data-load-success', {message: res.data.message})
          return res.data.response
      } catch (err) {
          this.eventBus.emit('data-load-error', {message: err, url})
      } finally {
          this.eventBus.emit('data-loaded')      
      }

  }

  async checkEstrattiConto(estrattoConto) {
    let items = []
    const url = `${this.baseUrl}/estratto-conto/detail/check-estratti-conto`

    try {
      const res = await this.http.post(url, { estrattoConto })
      items = Array.isArray(res.data) ? res.data : (res.data?.data || [])
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
      // eslint-disable-next-line no-unsafe-finally
      return { items }
    }
  }

  async checkPreImportEstrattoconto(file){
    let items = {}
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/estratti-conto/check-pre-import`
    let fd = new FormData();
    fd.append('file', file);

    try {
      let res = await this.http.post(url, fd, settings)
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      }
    }
  }


  async getBonusSociale(){
    let items = {}
    const url = `${this.baseUrl}/get-bonus-sociale`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getCheckRecessi(type, date, file){
    let items = {}
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/check/recessi`
    let fd = new FormData();
    fd.append('type', type);
    fd.append('date', date);
    for (let i = 0 ; i < file.length ; i++) {
      fd.append('files[]', file[i]); 
    }

    try {
      let res = await this.http.post(url, fd , settings)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getControlloConsumi(type, used, period, percentage){
    let items = {}
    const url = `${this.baseUrl}/get-controllo-consumi`

    try {
      let res = await this.http.post(url, {
          data: {
            'type': type,
            'used': used,
            'period': period,
            'percentage': percentage
          }
      })
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getReportPod(date){
    let items = {}
    const url = `${this.baseUrl}/get-report-pod/${date}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getInfoAndamentoCab(tipo = 'all', anno = null, codAgente = 1053){
    let items = {}
    const url = `${this.baseUrl}/get-info-andamento-cab`

    try {
        let res = await this.http.get(url, {
          params: {
            tipo,
            anno,
            cod_agente: codAgente
          }
        })
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async downloadInfoAndamentoCab(tipo = 'tutti', anno = null, codAgente = 1053){
    const url = `${this.baseUrl}/get-info-andamento-cab-export`

    try {
      const res = await this.http({
        url,
        method: 'GET',
        params: {
          tipo,
          anno,
          cod_agente: codAgente
        },
        responseType: 'blob',
      })

      this.filemanager.download(res)
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getControlloRid(from, to){
    let items = {}
    const url = `${this.baseUrl}/get-controllo-rid/${from}/${to}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getFornitoriControlloFatture(){
    let items = {}
    const url = `${this.baseUrl}/controllo/fatture/get-fornitori`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getFornitoriControlloFattureHasDetailsEe(){
    let items = {}
    const url = `${this.baseUrl}/controllo/fatture/ee/get-fornitori-has-details`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getFornitoriControlloFattureHasDetailsGas(){
    let items = {}
    const url = `${this.baseUrl}/controllo/fatture/gas/get-fornitori-has-details`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getConsumptionsControlloFattureFornitoriEe(dateStart, dateEnd, fornitoreId){
    let items = {}
    const url = `${this.baseUrl}/controllo/fatture/ee/get-consumption`

    try {
        let res = await this.http.post(url, {dateStart, dateEnd, fornitoreId})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getConsumptionsControlloFattureFornitoriGas(dateStart, dateEnd, fornitoreId){
    let items = {}
    const url = `${this.baseUrl}/controllo/fatture/gas/get-consumption`

    try {
        let res = await this.http.post(url, {dateStart, dateEnd, fornitoreId})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getControlloAcquistatoVendutoFornitori(date, tipo, tipoFornitura){
    let items = {}
    const url = `${this.baseUrl}/controllo/fatture/acquistato-venduto/${date}/${tipo}/${tipoFornitura}`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getQuantitaMateriaFornitoriDogane(dataEmissione, fornitori){
    let items = {}
    const url = `${this.baseUrl}/controllo/fatture/quantita/fornitori/dogane`

    try {
        let res = await this.http.post(url, {dataEmissione, fornitori})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getBanksTypeRid(){
    let items = {}
    const url = `${this.baseUrl}/banks/type-rid`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getSummaryRidsMonth(cod_type_pay_mode, type_sdd, type_date, year){
    let items = {}
    const url = `${this.baseUrl}/rid/riepilogo/mensile`

    try {
        let res = await this.http.post(url, {cod_type_pay_mode, type_sdd, type_date, year})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getSummaryInsoluti(obj, year, hasDetails, monthYear = null, rappresentante = 0){
    let items = {}
    const url = `${this.baseUrl}/insoluti/riepilogo/mensile`

    try {
        let res = await this.http.post(url, {obj, year, hasDetails, month_year: monthYear, rappresentante})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }

  async getSummaryInsolutiAgenti(year, month, calcoloMeseSelezionato = 0) {
    let items = {}
    const url = `${this.baseUrl}/insoluti/riepilogo/mensile/agenti`

    try {
      const res = await this.http.post(url, {
        year,
        month,
        calcolo_mese_selezionato: calcoloMeseSelezionato,
      })
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      }
    }
  }

  async getSummaryInsolutiRappresentanti(codAgente, year, month, calcoloMeseSelezionato = 0) {
    let items = {}
    const url = `${this.baseUrl}/insoluti/riepilogo/mensile/rappresentanti`

    try {
      const res = await this.http.post(url, {
        cod_agente: codAgente,
        year,
        month,
        calcolo_mese_selezionato: calcoloMeseSelezionato,
      })
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      }
    }
  }
  async sendPdfSummaryInsoluti(obj, year, hasDetails, monthYear = null, rappresentante = 0){
    let items = {}
    const url = `${this.baseUrl}/insoluti/riepilogo/mensile/send-pdf`

    try {
      let res = await this.http({
        url,
        method: 'POST',
        data: {obj, year, hasDetails, month_year: monthYear, rappresentante},
      })
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getSummaryPayments(dates, excludeRidAndCompensation, excludeOut){
    let items = {}
    const url = `${this.baseUrl}/payments/riepilogo`

    try {
        let res = await this.http.post(url, {dates,excludeRidAndCompensation, excludeOut})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async sendSummaryPayments(data){
    let item = {}
    const url = `${this.baseUrl}/payments/riepilogo/email`

    try {
        let res = await this.http.post(url, {data})
        item = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            item,
        }
    }

  }


  async getProfiles(){
    let items = {}
    const url = `${this.baseUrl}/profiles`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }
  
  async getUsersWithProfiles(){
    let items = {}
    const url = `${this.baseUrl}/profile/users`  

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async editUserProfile(value){
    const url = `${this.baseUrl}/profile/user/edit`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
        return true
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
        return false
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async deleteUser(value){
    const url = `${this.baseUrl}/profile/user/delete`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
        return true
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
        return false
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async createUser(value){
    let item = {}
    const url = `${this.baseUrl}/profile/user/create`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        item = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          item,
        }    
    }

  }

  async editFatturaVoci(value){
    const url = `${this.baseUrl}/fattura/voci/edit`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
        return true
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
        return false
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async deleteFatturaVoci(value){
    const url = `${this.baseUrl}/fattura/voci/delete`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
        return true
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
        return false
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async createFatturaVoce(value){
    const url = `${this.baseUrl}/fattura/voci/create`

    try {
        let res = await this.http.post(url, {
          data: value
        })
        this.eventBus.emit('data-load-success', {message: res.data})
        return true
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
        return false
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async getPrevisionalDispacciamento(file, data_decorrenza){
    let items = {}
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/previsionale/dispacciamento`
    let fd = new FormData();
    fd.append('data_decorrenza', data_decorrenza);
    for (let i = 0 ; i < file.length ; i++) {
      fd.append('files[]', file[i]); 
    }

    try {
      let res = await this.http.post(url, fd , settings)

      items = res.data

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          items,
        }
    }

  }


  async uploadFilePratiche(file, provider){
    let items = {}
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/pratiche/upload/file`
    let fd = new FormData();
    fd.append('provider', JSON.stringify(provider));
    for (let i = 0 ; i < file.length ; i++) {
      fd.append('files[]', file[i]); 
    }

    try {
      let res = await this.http.post(url, fd , settings)
      // this.eventBus.emit('data-load-success', {message: res.data.msg})
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          items,
        }
    }
  }

  async updatePratica(code){
    const url = `${this.baseUrl}/pratiche/update/massive/request/${code}`

    try {
      let res = await this.http.get(url)
      this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }

  async getPreviewSospensioniRiattivazioni(typeFornitura, typePratica){
    let items = {}
    const url = `${this.baseUrl}/preview/sospensioni-riattivazioni`  

    try {
        let res = await this.http.post(url, {typeFornitura, typePratica})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async previewRilascioTutela(typeFornitura) {
      let items = {};
      const url = `${this.praticheBase}/api/forniture-tutela/get-tutela-preview`;

      try {
          const res = await this.http.post(url, { typeFornitura });
          items = res.data;
      } catch (err) {
          this.eventBus.emit('data-load-error', { message: err, url });
      } finally {
          this.eventBus.emit('data-loaded');
      }

      return { items };
  }

  async getSospensioniRiattivazioniForniture(typeFornitura, typePratica, dateFrom, dateTo){
    let items = {}
    const url = `${this.baseUrl}/forniture/sospensioni-riattivazioni`  

    try {
        let res = await this.http.post(url, {typeFornitura, typePratica, dateFrom, dateTo})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async downloadFileSospRiattPratiche(items){

    const url = `${this.baseUrl}/forniture/sospensioni-riattivazioni/download`
    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: {items},
            responseType: 'blob',
          })
        //this.eventBus.emit('data-load-success', {message: res.data})

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }

  async getFornitureInCmor(typeFornitura, date, saldo, agente, codePod = null, codePdr = null){
    let items = {}
    const url = `${this.baseUrl}/forniture/cmor`

    try {
        let res = await this.http.post(url, {typeFornitura, date, saldo, agente, codePod, codePdr })
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getFornitureInCmorAutomatizzato(typeFornitura, date, saldo, agente) {
    const url = `${this.baseUrl}/forniture/cmor/automatizzato`

    try {
      const res = await this.http.post(url, {typeFornitura, date, saldo, agente })
      this.eventBus.emit('data-loaded')
      return {
        items: res.data
      }
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      throw err
    }
  }

 


  async generateAndSendFileCmor(objs){
    let items = {}
    const url = `${this.baseUrl}/forniture/cmor/generate/template`

    try {
        let res = await this.http.post(url, {objs})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async generateAndSendFileCmorAutomatizzato(objs){
    let items = {}
    const url = `${this.baseUrl}/forniture/cmor/generate/template/automatizzato`

    try {
        let res = await this.http.post(url, {objs, group_by: 'udd'})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  
  async getPrevisionaleIncassi(){
    let items = {}
    const url = `${this.baseUrl}/previsionale/incassi`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getInvoicesWithCmor(dates){
    let items = {}
    const url = `${this.baseUrl}/fatture/cmor`

    try {
        let res = await this.http.post(url, {dates})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async updateDataInvioToCmorSent(obj){
    let items = {}
    const url = `${this.baseUrl}/fatture/cmor/update/data_invio`

    try {
        let res = await this.http.post(url, {obj})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async addPrevisionalDates(dates){
    let items = {}
    const url = `${this.baseUrl}/previsionale/incassi/add/dates`

    try {
        let res = await this.http.post(url, {dates})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async getDetailsPrevisionalIncassiUscite(date){
    let items = {}
    const url = `${this.baseUrl}/previsionale/incassi/uscite/details`

    try {
        let res = await this.http.post(url, {date})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async getCostiPratiche(date){
    let items = {}
    const url = `${this.baseUrl}/get-costi-pratiche`

    try {
        let res = await this.http.post(url, {date})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  
  async addCostiPratiche(objs){
    let items = {}
    const url = `${this.baseUrl}/add-costi-pratiche`

    try {
        let res = await this.http.post(url, {objs})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getContabili(){
    let items = {}
    const url = `${this.baseUrl}/contabili/all`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }

  async verifyNewContabile(contabile){
    let items = []
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/contabile/verify`
    let fd = new FormData();
    fd.append('contabile', JSON.stringify(contabile));
    for (let i = 0 ; i < contabile.fileToUpload.length ; i++) {
      fd.append('files[]', contabile.fileToUpload[i]); 
    }
    

    try {
      let res = await this.http.post(url, fd , settings)
      items = res.data
      // this.eventBus.emit('data-load-success', {message: res.data.msg})
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      // eslint-disable-next-line no-unsafe-finally
      return {
        items
      }
    }

  }


  async importNewContabile(contabile){
    // let items = [] 
    const url = `${this.baseUrl}/contabile/import`

    try {
        let res = await this.http.post(url, {contabile})
        return res.data
        
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  async downloadContabileFile(path){

    const url = `${this.baseUrl}/contabile/file/download`
    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: {path},
            responseType: 'blob',
          })
        //this.eventBus.emit('data-load-success', {message: res.data})
        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }


  async deleteContabile(id){
    let items = {}
    const url = `${this.baseUrl}/contabile/${id}/delete`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getAnalisiFornitori(type, dateFrom, dateTo){
    let items = {}
    const url = `${this.baseUrl}/controllo/analisi-fornitori`

    try {
        let res = await this.http.post(url, {type, dateFrom, dateTo})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async checkInvoicesFromDescription(arr){

    let items = {}
    const url = `${this.baseUrl}/estratti-conto/check-invoices-from-description`

    try {
        let res = await this.http.post(url, { data:arr})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async associateAutoToPayments(objs){
    
    const url = `${this.baseUrl}/estratto-conto/detail/associate-auto-to-payments`

    try {
        let res = await this.http.post(url, {
          data: objs
        })
        this.eventBus.emit('data-load-success', {message: res.data.message})
        return res.data.response
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
    }

  }


  
  async foundCombinationsBollettini(objs){
    let items = {}
    const url = `${this.baseUrl}/estratto-conto/found/combinations/bollettini`

    try {
        let res = await this.http.post(url, {
          data: objs
        })
        // this.eventBus.emit('data-load-success', {message: res.data.message})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }

  }

  async associateBollettini(objs){

    const url = `${this.baseUrl}/estratto-conto/associate/bollettini`

    try {
        let res = await this.http.post(url, {
          data: objs
        })
        this.eventBus.emit('data-load-success', {message: res.data.message})
        return res.data.response
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }

  // Nuovo import bollettini (txt): restituiscono { ok, data } oppure { ok: false, message }
  async verificaBollettiniTxt(righe) {
    return this._bollettini('post', '/estratto-conto/bollettini/verifica', { righe })
  }

  async associaBollettiniTxt(movimenti) {
    return this._bollettini('post', '/estratto-conto/bollettini/associa', { movimenti })
  }

  async ricontrollaBollettiniTxt(righe) {
    return this._bollettini('post', '/estratto-conto/bollettini/ricontrolla', { righe })
  }

  async associazioniBollettiniTxt() {
    return this._bollettini('get', '/estratto-conto/bollettini/associazioni')
  }

  async annullaAssociazioneBollettiniTxt(id) {
    return this._bollettini('post', `/estratto-conto/bollettini/associazioni/${id}/annulla`)
  }

  async _bollettini(metodo, percorso, body) {
    const url = `${this.baseUrl}${percorso}`
    try {
      const res = await this.http[metodo](url, body)
      return { ok: true, data: res.data }
    } catch (err) {
      const message = err?.response?.data?.message
      if (!message) {
        this.eventBus.emit('data-load-error', { message: err, url })
      }
      return { ok: false, message: message || 'Errore imprevisto, riprova' }
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async previewAccreditiMps(file){
    let items = []
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/estratti-conto/preview-accrediti-mps`
    const formData = new FormData()
    formData.append('file', file)

    try {
        let res = await this.http.post(url, formData, settings)
        items = res.data
        return { items }
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
        throw err
    } finally {
        this.eventBus.emit('data-loaded')
    }
  }

  async verificaAccreditiMps(distinte, codTypePayMode){
    const url = `${this.baseUrl}/estratti-conto/verifica-accrediti-mps`

    try {
        let res = await this.http.post(url, {
          distinte,
          codTypePayMode
        })
        return { items: res.data }
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
        throw err
    } finally {
        this.eventBus.emit('data-loaded')
    }
  }

  async associaAccreditiMps(distinte){
    const url = `${this.baseUrl}/estratti-conto/associa-accrediti-mps`

    try {
        let res = await this.http.post(url, {
          distinte
        })
        return { items: res.data }
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
        throw err
    } finally {
        this.eventBus.emit('data-loaded')
    }
  }


  async importRicalcoli(file){
    let items = {}
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/estratti-conto/import/ricalcoli`
    let fd = new FormData();
    fd.append('file', file); 

    try {
      let res = await this.http.post(url, fd,  settings)
      items = res.data

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
         // eslint-disable-next-line no-unsafe-finally
        return {
          items,
        }      
    }

  }


  async importGiroconti(file){
    let items = {}
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/estratti-conto/import/giroconti`
    let fd = new FormData();
    fd.append('file', file); 

    try {
      let res = await this.http.post(url, fd,  settings)
      items = res.data

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
         // eslint-disable-next-line no-unsafe-finally
        return {
          items,
        }      
    }

  }



  async exportPdfInsoluti(items, removePaid){

    const url = `${this.baseUrl}/insoluti/riepilogo/mensile/pdf/download`
    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: {items, removePaid},
            responseType: 'blob',
          })
        //this.eventBus.emit('data-load-success', {message: res.data})

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }

  async exportCsvInsoluti(items, removePaid){

    const url = `${this.baseUrl}/insoluti/riepilogo/mensile/csv/download`
    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: {items, removePaid},
            responseType: 'blob',
          })
        //this.eventBus.emit('data-load-success', {message: res.data})

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }

  async exportPdfSummaryTable(items){

    const url = `${this.baseUrl}/insoluti/riepilogo/mensile/pdf/table/download`
    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: {items},
            responseType: 'blob',
          })
        //this.eventBus.emit('data-load-success', {message: res.data})

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }
  
  
  async getPdpReadyToSwitch(typeFornitura, typeTensione, typeProduzione, udds, distributors, typesOfferta, data_decorrenza){
    let response = {}
    const url = `${this.baseUrl}/switch-in/ready/to-switch`

    try {
        let res = await this.http.post(url, {typeFornitura, typeTensione, typeProduzione, udds, distributors, typesOfferta, data_decorrenza})
        // this.eventBus.emit('data-load-success', {message: res.data.message})
        response = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            response,
        } 
    }

  }


  async getPdpSwitchCaricati(typeFornitura,data_decorrenza,tipoSwitch){
    let items = {}
    const url = `${this.baseUrl}/switch-in/uploaded`

    try {
        let res = await this.http.post(url, {typeFornitura, data_decorrenza, tipoSwitch})
        // this.eventBus.emit('data-load-success', {message: res.data.message})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }

  }

  async getPdpSwitchCaricatiCache(typeFornitura,data_decorrenza,tipoSwitch){
    const url = `${this.baseUrl}/switch-in/uploaded/cache`;

    try {
      return await this.http.post(url, {typeFornitura, data_decorrenza, tipoSwitch})
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }
  }

  async deleteSwithInByDataDecorrenza(data_decorrenza) {
    const url = `${this.baseUrl}/switch-in/delete/data-decorrenza?data_decorrenza=${data_decorrenza}`;

    try {
      let res = await this.http.get(url);
      return res;
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    }
  }



  async downloadTemplateSwitchInProviders(items, providers, typeFornitura, total_kwh_available){

    const url = `${this.baseUrl}/switch-in/providers/template/download`
    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: {items, providers, typeFornitura, total_kwh_available},
            responseType: 'blob',
          })
        //this.eventBus.emit('data-load-success', {message: res.data})

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }


  async getUddsForSwitchin(typeFornitura){
    let items = {}
    const url = `${this.baseUrl}/switch-in/udds/${typeFornitura}/to-switch`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }

  }


  async uploadFileSwitchOk(file, typeFornitura){
    let item = {}
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/switch-in/${typeFornitura}/change/status`
    let fd = new FormData();
    fd.append('typeFornitura', typeFornitura); 
    for (let i = 0 ; i < file.length ; i++) {
      fd.append('files[]', file[i]); 
    }

    try {
      let res = await this.http.post(url, fd , settings)
      // this.eventBus.emit('data-load-success', {message: res.data.msg})
      item = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
        // eslint-disable-next-line no-unsafe-finally
        return {
          item,
        }
    }
  }


  async getDistributorsForSwitchin(typeFornitura){
    let items = {}
    const url = `${this.baseUrl}/switch-in/distributors/${typeFornitura}/to-switch`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }

  }


  async getTemplatesAvailable(){
    let items = {}
    const url = `${this.baseUrl}/switch-in/templates/available`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }

  }


  
  async generateTemplateSwitchinFromFile(file, typeFornitura, provider){
    
    const settings = { headers: { 'content-type': 'multipart/form-data' } }
    const url = `${this.baseUrl}/switch-in/generate/template/from-file`
    let fd = new FormData();
    fd.append('typeFornitura', typeFornitura); 
    fd.append('provider', JSON.stringify(provider)); 
    for (let i = 0 ; i < file.length ; i++) {
      fd.append('files[]', file[i]); 
    }

    try {
      // let res = await this.http.post(url, fd , settings)
      let res = 
        await this.http({
            url,
            method: 'POST',
            data: fd,
            responseType: 'blob',
            ...settings
          })

        this.filemanager.download(res)
      
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')
    }
  }


  async getSummaryProvvigioni(agentId, years, typeView, typeGroup){
    let items = []
    const url = `${this.baseUrl}/provvigioni/riepilogo`

    try {
      let res =  await this.http.post(url, {agentId, years, typeView, typeGroup})
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }

  }


  async getInternalPurchasePrice(){
    let items = {}
    const url = `${this.baseUrl}/prezzo-acquisto`

    try {
        let res = await this.http.get(url)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }
  }


  async saveInternalPurchasePrice(item){
    let success = {}
    const url = `${this.baseUrl}/prezzo-acquisto/save`

    try {
      let res =  await this.http.post(url, {item})
      success = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
          success,
        }
    }

  }


  async getSwitchOutCheck(typeFornitura, dataDecorrenza, dataPratica, showAnnullati) {
    let items = {};
    const url = `${this.praticheBase}/api/switch-management/display/switchout`;

    try {
      const res = await this.http.post(url, { typeFornitura, dataDecorrenza, dataPratica, showAnnullati });
      items = res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
    } finally {
      this.eventBus.emit('data-loaded');
    }

    return { items };
  }

  async setContrattiMensili(fd){
    let items = {}
    const url = `${this.baseUrl}/change-contratti-mensili`

    try {
        let res = await this.http.post(url, fd)
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }

  }


  async exportSwoutGroup(objs){

    const url = `${this.baseUrl}/switch-out/agents/group/download`
    try {
        let res = 
        await this.http({
            url,
            method: 'POST',
            data: {objs},
            responseType: 'blob',
          })

        this.filemanager.download(res)

    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }

  }

  
  async getStorniRidPayments(dates){
    let items = {}
    const url = `${this.apiUrl}/clienti/fatture/storni/rid`

    try {
        let res = await this.http.post(url, {dates})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }

  }




  async updateMotivazioni(motivazioniData) {
    const url = `${this.apiUrl}/clienti/fatture/storni/rid/motivazioni`;
  
    try {
  
      const res = await this.http.post(url, { motivazioni: motivazioniData });
  
      if (res.status === 200) {
        this.eventBus.emit('motivazioni-update-success', {
          message: 'Motivazioni aggiornate con successo'
        });
      }
    } catch (err) {
      this.eventBus.emit('motivazioni-update-error', {
        message: 'Errore durante l\'aggiornamento delle motivazioni',
        error: err
      });
    } finally {
      this.eventBus.emit('motivazioni-update-complete');
    }
  }



  async sendEmailToAgents(agentData) {
    const url = `${this.apiUrl}/clienti/fatture/storni/rid/invio/agenti`;
  
    try {
      const res = await this.http.post(url, {
        agentData: agentData
      });
  
      if (res.status === 200) {
        this.eventBus.emit('email-agenti-success', {
          message: 'Email inviate con successo',
        });
      }
    } catch (err) {
      this.eventBus.emit('email-agenti-error', {
        message: "Errore durante l'invio delle email agli agenti",
        error: err,
      });
    } finally {
      this.eventBus.emit('email-agenti-complete');
    }
  }

  async generatePDFStorniRid(agentName, data) {
    const url = `${this.apiUrl}/clienti/fatture/storni/rid/generate-pdf-storni`; 
    try {
      const response = await this.http.post(
        url,
        { agentName, data },
        {
          responseType: 'blob', 
        }
      );
      return response;
    } catch (error) {
      console.error('Error generating PDF:', error);
      throw error;
    }
  }




  async sendEmailStorniRidPayments(objs){
    let items = {}
    const url = `${this.apiUrl}/clienti/fatture/storni/rid/invio`

    try {
        let res = await this.http.post(url, {objs})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }

  }

  async downloadCsvProvvigioni(agentId, month){
    const url = `${this.baseUrl}/provvigioni/riepilogo/export`

    try {
      let res = await this.http({
          url,
          method: 'POST',
          data: {agentId, month},
          responseType: 'blob',
        })
      //this.eventBus.emit('data-load-success', {message: res.data})
      this.filemanager.download(res)
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
    }
  }

  async exportSummaryProvvigioniByYear(agentId, year, detail = false) {
    const url = `${this.baseUrl}/provvigioni/riepilogo/export/anno`
    try {
      const res = await this.http({
        url,
        method: 'POST',
        data: { agentId, year, detail },
        responseType: 'blob',
      })
      this.filemanager.download(res)
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getPrevisionalUsciteFuture(dates = null) {
    let items = {}
    const url = `${this.baseUrl}/previsionale/uscite/future`
    const config = dates ? { params: { dates } } : {}

    try {
        let res = await this.http.get(url, config)
        items = res.data
        return {
            items,
        }
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
        return {
            items,
        }
    } finally {
        this.eventBus.emit('data-loaded')      
    }
  }

  async getScadenzaFatturePerGrafico() {
    let items = []
    const url = `${this.baseUrl}/previsionale/scadenza/fatture/grafico`
  
    try {
      let res = await this.http.get(url)
      items = res.data
      return { items }
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return { items }
    } finally {
      this.eventBus.emit('data-loaded')      
    }
  }
  
  async getDettaglioUsciteSettimanali(weekIndex) {
    let items = []
    const url = `${this.baseUrl}/previsionale/scadenza/fatture/dettaglio-uscite/${weekIndex}`
  
    try {
      let res = await this.http.post(url)
      items = res.data
      return { items }
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return { items }
    } finally {
      this.eventBus.emit('data-loaded')      
    }
  }
  
  async getDettaglioIncassiSettimanali(weekIndex) {
    let items = []
    const url = `${this.baseUrl}/previsionale/scadenza/fatture/dettaglio-incassi/${weekIndex}`
  
    try {
      let res = await this.http.post(url)
      items = res.data
      return { items }
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return { items }
    } finally {
      this.eventBus.emit('data-loaded')      
    }
  }

  async getPrevisionalePod() {

    const url = `${this.praticheBase}/api/previsionale/pod`;

    try {
      let result = await this.http.get(url);
      return result.data;
    } catch (error) {
      this.eventBus.emit('data-load-error', {message: error, url});
    }
  }

  async getPrevisionalePdr() {

    const url = `${this.praticheBase}/api/previsionale/pdr`;

    try {
      let result = await this.http.get(url);
      return result.data;
    } catch (error) {
      this.eventBus.emit('data-load-error', {message: error, url});
    }
  }

  async getPrevisionaleUddAgentiPod() {

    const url = `${this.praticheBase}/api/previsionale/pod/udd-agenti`;

    try {
      let result = await this.http.get(url);
      return result.data;
    } catch (error) {
      this.eventBus.emit('data-load-error', {message: error, url});
    }
  }

  async getPrevisionaleUddAgentiPdr() {

    const url = `${this.praticheBase}/api/previsionale/pdr/udd-agenti`;

    try {
      let result = await this.http.get(url);
      return result.data;
    } catch (error) {
      this.eventBus.emit('data-load-error', {message: error, url});
    }
  }

  async getPrevisionaleDettagliPod(page, filtroPod, sortField = null, sortOrder = null) {
    
    let url = `${this.praticheBase}/api/previsionale/pod/dettagli?page=${page}&search=${encodeURIComponent(filtroPod)}`;

    if (sortField && sortOrder !== null) {
      url += `&sortField=${sortField}&sortOrder=${sortOrder}`;
    }

    try {
      let result = await this.http.get(url);
      return result.data;
    } catch (error) {
      this.eventBus.emit('data-load-error', { message: error, url });
    }
  }

  async getPrevisionaleDettagliPdr(page, filtroPdr, sortField = null, sortOrder = null) {

    let url = `${this.praticheBase}/api/previsionale/pdr/dettagli?page=${page}&search=${encodeURIComponent(filtroPdr)}`;

    if (sortField && sortOrder !== null) {
      url += `&sortField=${sortField}&sortOrder=${sortOrder}`;
    }

    try {
      let result = await this.http.get(url);
      return result.data;
    } catch (error) {
      this.eventBus.emit('data-load-error', {message: error, url});
    }
  }

  async exportPodDettagliPrevisionalePod() {
    window.open(`${this.praticheBase}/api/previsionale/pod/dettagli/export`, '_blank');
  }

  async exportPodDettagliPrevisionalePdr() {
    window.open(`${this.praticheBase}/api/previsionale/pdr/dettagli/export`, '_blank');
  }

  async getPrevisionaleSwitchout() {

    let items = {};
    const url = `${this.baseUrl}/previsionale/fornitura`;

    try {
      let result = await this.http.get(url);
      items = result.data;
    } catch (error) {
      this.eventBus.emit('data-load-error', {message: error, url});
    } finally {
      this.eventBus.emit('data-loaded');
    }

    return items;
  }

  async getPodDetailsPrevisionaleSwitchout(page) {

    let items = {};
    const url = `${this.baseUrl}/previsionale/fornitura/details/pod?page=${page}`;

    try {
      let result = await this.http.get(url);
      items = result.data;
    } catch (error) {
      this.eventBus.emit('data-load-error', {message: error, url});
    } finally {
      this.eventBus.emit('data-loaded');
    }

    return items;
  }

  async getPdrDetailsPrevisionaleSwitchout(page) {

    let items = {};
    const url = `${this.baseUrl}/previsionale/fornitura/details/pdr?page=${page}`;

    try {
      let result = await this.http.get(url);
      items = result.data;
    } catch (error) {
      this.eventBus.emit('data-load-error', {message: error, url});
    } finally {
      this.eventBus.emit('data-loaded');
    }

    return items;
  }

  async getInfoFromPraticheDossier() {
    let items = {}
    const url = `${this.baseUrl}/pratiche/dossier/info`
    
    try {
      let res = await this.http.post(url)
      items = res.data
      return { items }
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return { items }
    } finally {
      this.eventBus.emit('data-loaded')      
    }
  }


  async getInfoCodiciContoMeseCompetenza(params) {
    let items = {}
    const url = `${this.baseUrl}/get-info-codici-conto-mese-competenza`
  
    try {
      let res = await this.http.post(url, params)
      items = res.data
      return { items }
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
      return { items }
    } finally {
      this.eventBus.emit('data-loaded')      
    }
  }

  async getInfoRichiesteRimborso(params = {}) {
    const url = `${this.baseUrl}/get-info-richieste-rimborso`

    try {
      const res = await this.http.get(url, { params })
      const body = res.data ?? {}
      let items = []

      if (Array.isArray(body.data)) {
        items = body.data
      } else if (body.data && typeof body.data === 'object') {
        items = [body.data]
      }

      return {
        items,
        pagination: {
          current_page: body.current_page ?? 1,
          per_page: body.per_page ?? params.per_page ?? 50,
          total: body.total ?? items.length,
          last_page: body.last_page ?? 1,
        },
      }
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async confirmRichiestaRimborso({ id, numero }) {
    const url = `${this.baseUrl}/confirm-richiesta-rimborso`

    try {
      const res = await this.http.post(url, { id, numero })
      return res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  // Gli errori (formato, dimensione, SFTP) li mostra la pagina con il messaggio del backend
  async uploadRicevutaRimborso(id, file, onProgress = null) {
    const url = `${this.baseUrl}/richiesta-rimborso/ricevuta`
    const formData = new FormData()
    formData.append('id', id)
    formData.append('file', file)

    const res = await this.http.post(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (event) => {
        if (onProgress && event.total) {
          onProgress(Math.round((event.loaded * 100) / event.total))
        }
      },
    })
    return res.data
  }

  async downloadRicevutaRimborso({ id, numero }) {
    const url = `${this.baseUrl}/richiesta-rimborso/ricevuta/download`

    try {
      const res = await this.http.get(url, {
        params: { id },
        responseType: 'blob',
      })

      const contentType = res.headers?.['content-type'] || res.headers?.['Content-Type'] || ''
      if (contentType.includes('application/json')) {
        const text = await res.data.text()
        let message = 'Allegato non trovato'

        try {
          const json = JSON.parse(text)
          message = json.message || message
        } catch (parseError) {
          // ignore parse errors
        }

        throw new Error(message)
      }

      let filename = `${numero}_ricevuta`
      const contentDisposition = res.headers?.['content-disposition'] || res.headers?.['Content-Disposition']

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^";]+)"?/i)
        if (match?.[1]) {
          filename = match[1]
        }
      }

      const blob = new Blob([res.data], { type: contentType || 'application/octet-stream' })
      const urlBlob = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = urlBlob
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
      window.URL.revokeObjectURL(urlBlob)

      return true
    } catch (err) {
      if (err?.response?.data instanceof Blob) {
        try {
          const text = await err.response.data.text()
          const json = JSON.parse(text)
          throw new Error(json.message || 'Allegato non trovato')
        } catch (parseError) {
          if (parseError instanceof Error && parseError.message !== 'Allegato non trovato') {
            throw parseError
          }
        }
      }

      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getDataForEmailOrFrontendSwoutCredito(tipoFornitura, date) {
    let items = {}
    const url = `${this.praticheBase}/api/switch-management/display/switchout/credito`

    try {
        let res = await this.http.post(url, {tipoFornitura, date})
        items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')   
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        } 
    }
  }

  async getQualitaAgenteFirmatario(dataInizio, dataFine) {
    let items = {}
    const url = `${this.baseUrl}/qualita-agente-firmatario?data_inizio=${dataInizio}&data_fine=${dataFine}`;

    try {
      const res = await this.http.get(url)
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return { items }
  }

  
  async importCmorResponse(file) {
    const url = `${this.baseUrl}/forniture/cmor/import/response`;
    const formData = new FormData();
    formData.append('file', file);
    let items = {};

    try {
      const res = await this.http.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      items = res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
      throw err;
    } finally {
      this.eventBus.emit('data-loaded');
      // eslint-disable-next-line no-unsafe-finally
      return {
          items,
      };
    }
  }

  async importFileCmorLavorate(file) {
    const url = `${this.baseUrl}/cmor/lavorate/import`;
    const formData = new FormData();
    formData.append('file', file);
    let items = {};

    try {
      const res = await this.http.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      items = res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
      throw err;
    } finally {
      this.eventBus.emit('data-loaded');
      // eslint-disable-next-line no-unsafe-finally
      return { items };
    }
  }

  async importCmorFiles(files, tipo, dataInvio = null) {
    const url = `${this.baseUrl}/cmor/files/import`;
    const formData = new FormData();
    formData.append('tipo', tipo);
    
    if (tipo === 'risposta' && dataInvio) {
      formData.append('data_invio', dataInvio);
    }
    
    if (Array.isArray(files)) {
      files.forEach(file => {
        formData.append('files[]', file);
      });
    } else {
      formData.append('files[]', files);
    }
    
    let items = {};

    try {
      const res = await this.http.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      items = res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
      throw err;
    } finally {
      this.eventBus.emit('data-loaded');
      // eslint-disable-next-line no-unsafe-finally
      return { items };
    }
  }

  async riepilogoCmorResponse(date = null) {
    const url = `${this.baseUrl}/forniture/cmor/riepilogo`;
    try {
      const payload = date ? { date } : {};
      const res = await this.http.post(url, payload);
      return res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
      throw err;
    }
  }

  async getCmorDaAnnullare() {
    const url = `${this.baseUrl}/cmor/check/da-annullare`;
    let items = {};

    try {
      const res = await this.http.get(url);
      items = res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
    } finally {
      this.eventBus.emit('data-loaded');
      // eslint-disable-next-line no-unsafe-finally
      return { items };
    }
  }

  async generateTemplateAnnullamentoCmor(pods = [], pdrs = [], codUser = null) {
    const url = `${this.baseUrl}/cmor/generate/template/annullamento`;
    try {
      const res = await this.http({
        url,
        method: 'POST',
        data: { pods, pdrs, cod_user: codUser },
        responseType: 'blob',
      });
      let filename = 'annullamento_cmor.csv';
      const contentDisposition = res.headers && (res.headers['content-disposition'] || res.headers['Content-Disposition']);
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^";]+)"?/i);
        if (match && match[1]) {
          filename = match[1];
        }
      }

      const blob = new Blob([res.data], { type: 'text/csv; charset=UTF-8' });
      const urlBlob = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = urlBlob;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(urlBlob);
      return true;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
      return false;
    } finally {
      this.eventBus.emit('data-loaded');
    }
  }

  async getInfoCmorLavorateDate(tipo) {
    let items = {};
    const url = `${this.baseUrl}/cmor/lavorate/get-date`;

    try {
      const res = await this.http.get(url, {
        params: {
          tipo: tipo
        }
      });
      items = res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
    } finally {
      this.eventBus.emit('data-loaded');
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

  async getInfoCmorLavorateRecords(tipo, anno, mese) {
    let items = {};
    const url = `${this.baseUrl}/cmor/lavorate/get-records`;

    try {
      const res = await this.http.get(url, {
        params: {
          tipo: tipo,
          anno: anno,
          mese: mese
        }
      });
      items = res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
    } finally {
      this.eventBus.emit('data-loaded');
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      };
    }
  }

}


